const CreditMemoStatusOptionsArray = [
  { value: 'Created', label: 'Created' },
  { value: 'Approved By Submitter', label: 'Approved By Submitter' },
  { value: 'Approved By Line Manager', label: 'Approved By Line Manager' },
  { value: 'Approved By CM Approver', label: 'Approved By CM Approver' },
  { value: 'Declined', label: 'Declined' },
  { value: 'Finalized', label: 'Finalized' },
];
export default CreditMemoStatusOptionsArray;
